<template>
  <div class="rating-input">
    <div
      class="rating-input__fields d-flex justify-content-between align-items-center"
    >
      <div class="rating-input__label-tooltip" :class="tooltipClasses">
        <span>
          {{ data.label }}
          <img
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="data.tooltip"
            :src="require('@/assets/icons/help.svg')"
            alt="help-icon"
          />
        </span>
      </div>
      <div class="rating-input__field" :class="data.field_type">
        <component
          @changeValue="changeValue"
          :is="data.field_type"
          :data="data"
          :targetRating="10"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FieldScore from './fields/fieldScore';
import FieldTextArea from './fields/fieldTextArea';
import FieldScoreNumber from './fields/fieldScoreNumber';

export default {
  name: 'InputRating',
  components: {
    score: FieldScore,
    score_number: FieldScoreNumber,
    text_input: FieldTextArea,
  },
  props: {
    data: {},
    fieldsScore: 0,
  },
  data() {
    return {
      fieldDictionary: {
        text_input: {
          tooltipClasses: ['hide'],
        },
        score: {
          tooltipClasses: [],
        },
        score_number: {
          tooltipClasses: ['hide'],
        },
      },
    };
  },
  methods: {
    changeValue(data) {
      this.$emit('change', data);
    },
  },
  computed: {
    tooltipClasses() {
      const fieldDictionary = this.fieldDictionary[this.data.field_type];
      if (fieldDictionary) {
        return this.fieldDictionary[this.data.field_type].tooltipClasses.join(
          ' '
        );
      }

      return '';
    },
  },
};
</script>

<style lang="scss">
.rating-input {
  &__label-tooltip {
    flex: 1;
  }

  &__label-tooltip {
    font-size: 20px;
  }

  .hide {
    display: none;
  }

  &__fields {
    flex-wrap: wrap;
    margin-bottom: toRem(10px);
  }

  &__field {
    flex: 1;

    .b-rating {
      border: none;
      font-size: 25px;

      span {
        border-color: red !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/rating/input.vue